import { Link } from 'react-router-dom'

import { Dialog, DialogActions, DialogContent, DialogTitle, Button } from '@mui/material'

const ActionErrorDialog = ({ title, open, setOpen, error }) => {
  const normalisedError = typeof error === "string"
    ? { message: error }
    : (error ?? { message: "An unexpected error occurred." })

  const close = (e, reason) => {
    if (reason && reason === "backdropClick")
      return
    setOpen(false)
  }

  if (open) {
    return (
      <Dialog
        open={open}
        onClose={close}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {title}
        </DialogTitle>

        <DialogContent>
          {normalisedError.message}

          {(normalisedError.name === 'InsufficientCreditsError') &&
            <div className='mt-5'>Click the link below to purchase additional credits</div>
          }
        </DialogContent>

        <DialogActions>
          <div className="flex flex-row justify-between w-full p-5">
            <div className='flex flex-row gap-5'>
              {(normalisedError.name === 'InsufficientCreditsError') &&
                <Link to="/billing/" className='link'>get more credits</Link>
              }
            </div>

            <Button variant="contained" onClick={close} autoFocus >Close</Button>
          </div>
        </DialogActions>
      </Dialog>
    )
  }

}

export default ActionErrorDialog
